module.exports = function _isNumber(x) {
  return Object.prototype.toString.call(x) === '[object Number]';
};



//////////////////
// WEBPACK FOOTER
// ./~/ramda/src/internal/_isNumber.js
// module id = ./node_modules/ramda/src/internal/_isNumber.js
// module chunks = 54 55 56